import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the service worker for offline detection + app-shell caching.
// Wrapped in a load handler so the SW registration doesn't compete with
// the initial render for network bandwidth.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => {
        // Non-fatal — app still works without the SW; just no offline cache.
        // eslint-disable-next-line no-console
        console.warn("CartIQ 360 service worker failed to register:", err);
      });
  });
}
